import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RateReviewModal from './RateReviewModal';
import { useEffect } from "react";

const PurchaseOrderDetails = () => {
useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  const { purchaseId } = useParams();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemRatings, setItemRatings] = useState({});

  // Mock function to get purchase data based on purchaseId
  // In a real app, this would fetch from an API or context
  const getPurchaseData = (id) => {
    const allPurchases = [
      {
        id: "#PUR57986418741",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true"
          }
        ],
        status: "Placed",
        orderDate: "Ordered on 25 May, 2023 08:30 PM"
      },
      {
        id: "#PUR57986418742",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true"
          },
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0b475407c9838c9be07495ac10e54e5567924867?placeholderIfAbsent=true"
          }
        ],
        status: "Shipped",
        orderDate: "Ordered on 26 May, 2023 09:30 PM"
      },
      {
        id: "#PUR57986418743",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true"
          },
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0b475407c9838c9be07495ac10e54e5567924867?placeholderIfAbsent=true"
          }
        ],
        status: "Placed",
        orderDate: "Ordered on 27 May, 2023 10:30 PM"
      },
      {
        id: "#PUR57986418744",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true"
          }
        ],
        status: "Delivered",
        orderDate: "Ordered on 20 May, 2023 07:30 PM",
        deliveredDate: "22 May, 2023"
      },
      {
        id: "#PUR57986418745",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0b475407c9838c9be07495ac10e54e5567924867?placeholderIfAbsent=true"
          }
        ],
        status: "Delivered",
        orderDate: "Ordered on 18 May, 2023 06:30 PM",
        deliveredDate: "20 May, 2023"
      },
      {
        id: "#PUR57986418746",
        items: [
          {
            name: "Loveable for someone Teddy Bear",
            quantity: 1,
            image: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/0465be2e26a19f5e9835d94b44a95e75ffdc6a42?placeholderIfAbsent=true"
          }
        ],
        status: "Delivered",
        orderDate: "Ordered on 15 May, 2023 05:30 PM",
        deliveredDate: "17 May, 2023"
      }
    ];

    const fullPurchaseId = `#${id}`;
    return allPurchases.find(purchase => purchase.id === fullPurchaseId) || allPurchases[0];
  };

  const purchaseData = getPurchaseData(purchaseId);

  // Create unique item identifier
  const getItemId = (item, index) => {
    return `${item.name}_${index}_${item.image}`;
  };

  // Handle review submission
  const handleReviewSubmit = (reviewData) => {
    setItemRatings(prev => ({
      ...prev,
      [reviewData.itemId]: reviewData.rating
    }));
  };

  // Create purchase data structure for the component
  const formattedPurchaseData = {
    purchaseInfo: {
      purchaseId: purchaseData.id,
      orderedAt: purchaseData.orderDate.replace('Ordered on ', ''),
      status: purchaseData.status,
      payment: 'Card'
    },
    deliveryAddress: {
      name: 'Jaane Cooper',
      address: '4517 Washington Ave. Manchester, Kentucky Preston Rd. Inglewood, 987456',
      phone: '+1 888 3685 368'
    },
    items: purchaseData.items.map((item, index) => ({
      ...item,
      id: getItemId(item, index),
      status: purchaseData.status
    })),
    purchaseSummary: {
      premiumChargeLabel: 'Premium toys charge',
      premiumCharge: '$30.00',
      shippingChargeLabel: 'Shipping charge',
      shippingCharge: '$10.00',
      discountLabel: 'Discount',
      discountSubLabel: '(Premium toys)',
      discount: '-$10.00',
      total: '$30.00'
    },
    actions: [
      {
        label: 'Rate & Review',
        primary: false,
        onClick: () => setIsModalOpen(true),
        hideWhenAllRated: true
      },
      {
        label: 'Reorder',
        primary: false,
        onClick: () => console.log('Reorder clicked')
      }
    ]
  };

  // Check if all items have been rated
  const areAllItemsRated = () => {
    return formattedPurchaseData.items.every(item => itemRatings[item.id]);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered':
        return 'text-green-500';
      case 'pending':
        return 'text-yellow-500';
      case 'cancelled':
        return 'text-red-500';
      case 'shipped':
        return 'text-indigo-400';
      case 'placed':
        return 'text-red-500';
      default:
        return 'text-sky-950';
    }
  };

  const getItemStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered':
        return 'text-green-500';
      case 'shipped':
        return 'text-indigo-400';
      case 'placed':
        return 'text-red-500';
      default:
        return 'text-sky-950 opacity-70';
    }
  };

  const renderItemContent = (item) => {
    const status = item.status?.toLowerCase();
    const itemRating = itemRatings[item.id];

    if (status === 'placed' || status === 'shipped') {
      return (
        <>
          <div className="text-base text-sky-950">
            {item.name}
          </div>
          <div className="flex items-center self-start text-sm whitespace-nowrap text-sky-950 w-full relative">
            <span className="self-stretch my-auto text-sky-950 opacity-70">
              {item.quantity} quantity
            </span>
            {itemRating && (
              <div className="flex items-center gap-1 absolute right-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="#fbbf24"
                  className="flex-shrink-0"
                >
                  <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    stroke="#f59e0b"
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-sm font-medium text-sky-950">{itemRating}</span>
              </div>
            )}
          </div>
        </>
      );
    } else if (status === 'delivered') {
      return (
        <>
          <div className="text-base text-sky-950">
            {item.quantity} X {item.name}
          </div>
          <div className="flex items-center self-start text-sm whitespace-nowrap text-sky-950 w-full relative">
            <span className="self-stretch my-auto text-sky-950 opacity-70">
              Delivered permanently
            </span>
            {itemRating && (
              <div className="flex items-center gap-1 absolute right-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="#fbbf24"
                  className="flex-shrink-0"
                >
                  <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    stroke="#f59e0b"
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-sm font-medium text-sky-950">{itemRating}</span>
              </div>
            )}
          </div>
        </>
      );
    } else {
      // Default fallback
      return (
        <>
          <div className="text-base text-sky-950">
            {item.quantity} X {item.name}
          </div>
          <div className="flex items-center self-start text-sm whitespace-nowrap text-sky-950 w-full relative">
            <span className={`self-stretch my-auto ${getItemStatusColor(item.status)}`}>
              {item.status}
            </span>
            {itemRating && (
              <div className="flex items-center gap-1 absolute right-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="#fbbf24"
                  className="flex-shrink-0"
                >
                  <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    stroke="#f59e0b"
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-sm font-medium text-sky-950">{itemRating}</span>
              </div>
            )}
          </div>
        </>
      );
    }
  };

  const getVisibleActions = () => {
    return formattedPurchaseData.actions.filter(action => {
      // Hide Rate & Review button if all items are rated
      if (action.hideWhenAllRated && areAllItemsRated()) {
        return false;
      }
      return true;
    });
  };

  return (
    <main className="ml-5 w-[73%] max-md:ml-0 max-md:w-full">
      <div className="flex flex-col grow items-center max-md:mt-9 max-md:max-w-full">
        {/* Purchase Information Section */}
        <section className="max-w-full rounded-none w-[804px]">
          <div className="flex flex-col px-5 py-4 w-full bg-white rounded-2xl shadow-2xl max-md:max-w-full">
            <h2 className="self-start text-lg font-semibold leading-none text-sky-950">
              Purchase Information
            </h2>
            <div className="shrink-0 mt-2.5 h-px border border-solid border-neutral-300 max-md:max-w-full" />
            <div className="flex flex-wrap gap-1.5 justify-between items-start mt-3 w-full text-base max-md:max-w-full">
              <div className="flex justify-between rounded-none min-w-60 text-sky-950 w-[307px]">
                <span className="opacity-50 text-sky-950">Purchase ID</span>
                <span className="font-medium text-sky-950">
                  {formattedPurchaseData.purchaseInfo.purchaseId}
                </span>
              </div>
              <div className="flex justify-between rounded-none min-w-60 text-sky-950 w-[307px]">
                <span className="opacity-50 text-sky-950">Ordered At</span>
                <span className="font-medium text-sky-950">
                  {formattedPurchaseData.purchaseInfo.orderedAt}
                </span>
              </div>
              <div className="flex justify-between whitespace-nowrap rounded-none min-w-60 w-[307px]">
                <span className="opacity-50 text-sky-950">Status</span>
                <span className={`font-medium ${getStatusColor(formattedPurchaseData.purchaseInfo.status)}`}>
                  {formattedPurchaseData.purchaseInfo.status}
                </span>
              </div>
              <div className="flex justify-between whitespace-nowrap rounded-none min-w-60 text-sky-950 w-[307px]">
                <span className="opacity-50 text-sky-950">Payment</span>
                <span className="font-medium text-sky-950">
                  {formattedPurchaseData.purchaseInfo.payment}
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Delivery Address Section */}
        <section className="mt-4 max-w-full text-base font-semibold rounded-none text-sky-950 w-[804px]">
          <div className="flex flex-col items-start px-5 py-4 w-full bg-white rounded-2xl shadow-2xl max-md:max-w-full">
            <h2 className="text-lg leading-none text-sky-950">
              Delivery address
            </h2>
            <div className="shrink-0 self-stretch mt-2.5 w-full h-px border border-solid border-neutral-300" />
            <div className="flex gap-2.5 items-center mt-2">
              <span className="self-stretch my-auto text-sky-950">
                {formattedPurchaseData.deliveryAddress.name}
              </span>
            </div>
            <address className="mt-1.5 tracking-normal text-black opacity-60 max-md:max-w-full not-italic">
              {formattedPurchaseData.deliveryAddress.address}
            </address>
            <div className="mt-1.5 text-sm tracking-normal text-black opacity-60">
              {formattedPurchaseData.deliveryAddress.phone}
            </div>
          </div>
        </section>

        {/* Items Section */}
        <section className="mt-4 max-w-full font-medium rounded-none w-[804px]">
          <div className="flex flex-col items-start px-5 py-4 bg-white rounded-2xl shadow-2xl max-md:max-w-full">
            <h2 className="text-lg font-semibold leading-none text-sky-950">
              Items
            </h2>
            <div className="shrink-0 self-stretch mt-2.5 w-full h-px border border-solid border-neutral-300" />
            <div className="flex flex-col items-start mt-2.5 max-w-full w-[732px] gap-3.5">
              {formattedPurchaseData.items.map((item, index) => (
                <div key={index} className="flex gap-3 max-w-full rounded-none w-full">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="object-contain shrink-0 self-start rounded-md aspect-square w-[46px]"
                  />
                  <div className="flex flex-col grow shrink-0 basis-0 w-fit">
                    {renderItemContent(item)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Purchase Summary Section */}
        <section className="mt-4 max-w-full text-lg rounded-2xl w-[804px]">
          <div className="flex flex-col px-5 py-4 w-full bg-white rounded-2xl shadow-2xl max-md:max-w-full">
            <h2 className="self-start font-semibold leading-none text-sky-950">
              Purchase Summary
            </h2>
            <div className="shrink-0 mt-2.5 max-w-full h-px border border-solid border-neutral-300 w-[764px]" />
            <div className="flex flex-wrap gap-5 justify-between mt-4 text-base tracking-normal max-md:max-w-full">
              <div className="flex flex-col text-sky-950">
                <div className="opacity-90 text-sky-950 max-md:mr-2.5">
                  {formattedPurchaseData.purchaseSummary.premiumChargeLabel}
                </div>
                <div className="self-start mt-3 opacity-90 text-sky-950">
                  {formattedPurchaseData.purchaseSummary.shippingChargeLabel}
                </div>
                <div className="mt-3 opacity-90 text-sky-950">
                  {formattedPurchaseData.purchaseSummary.discountLabel}{' '}
                  <span style={{fontWeight: 600, fontSize: '14px'}}>
                    {formattedPurchaseData.purchaseSummary.discountSubLabel}
                  </span>
                </div>
              </div>
              <div className="font-medium text-right whitespace-nowrap">
                <div className="flex flex-col pl-1.5">
                  <div className="text-sky-950">
                    {formattedPurchaseData.purchaseSummary.premiumCharge}
                  </div>
                  <div className="self-start mt-3 text-sky-950">
                    {formattedPurchaseData.purchaseSummary.shippingCharge}
                  </div>
                </div>
                <div className="mt-3 text-red-500">
                  {formattedPurchaseData.purchaseSummary.discount}
                </div>
              </div>
            </div>
            <div className="shrink-0 mt-4 max-w-full h-px border border-solid border-neutral-200 w-[764px]" />
            <div className="flex flex-wrap gap-5 justify-between mt-5 font-semibold tracking-normal whitespace-nowrap text-sky-950 max-md:max-w-full">
              <span className="text-sky-950">Total</span>
              <span className="text-right text-sky-950">
                {formattedPurchaseData.purchaseSummary.total}
              </span>
            </div>
          </div>
        </section>

        {/* Action Buttons */}
        {/* {getVisibleActions().length > 0 && (
          <div className="flex flex-wrap gap-5 justify-center items-center mt-5 max-w-full text-base font-semibold tracking-wide leading-tight text-center w-[761px] max-md:mr-2.5">
            {getVisibleActions().map((action, index) => (
              <button
                key={index}
                className={`flex gap-10 justify-center items-center px-5 py-4 rounded-2xl border-b border-white border-opacity-30 min-h-[50px] transition-all duration-200 ${
                  action.primary
                    ? 'text-white bg-green-500 shadow-lg border-b-white border-b-opacity-30'
                    : 'text-neutral-600 bg-zinc-300 hover:text-white hover:bg-green-500 hover:shadow-lg'
                }`}
                onClick={action.onClick}
                disabled={action.disabled}
                aria-label={action.ariaLabel || action.label}
              >
                <span className={action.primary ? 'text-white' : ''}>
                  {action.label}
                </span>
              </button>
            ))}
          </div>
        )} */}
      </div>

      {/* Rate & Review Modal */}
      <RateReviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        items={formattedPurchaseData.items}
        onSubmitReview={handleReviewSubmit}
        itemRatings={itemRatings}
      />
    </main>
  );
};

export default PurchaseOrderDetails;
